// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledBox } from "@ces/XDL/Components/Common/Box";
import { color, xScreen } from "@ces/XDL/Utilities";
import { addressDrawerFulfillmentMethodSelectorStyles } from "@insite/content-library/Widgets/Header/AddressDrawerFulfillmentMethodSelector";
import { css } from "styled-components";

addressDrawerFulfillmentMethodSelectorStyles.container = {
    css: css`
        ${styledBox}
        width: 100%;

        ${xScreen("lte", "md")} {
            padding: 16px;
        }
    `,
};

addressDrawerFulfillmentMethodSelectorStyles.radioGroup = {
    labelProps: {
        forwardAs: "p",
        css: css`
            &&&& {
                margin: 0;
                display: inline-flex;
                line-height: 26px;
                font-size: 20px;
                float: left;
                ${xScreen("lte", "md")} {
                    width: 100%;
                    padding-bottom: 16px;
                    float: none;
                }
            }
        `,
    },
    css: css`
        display: flex;
        gap: 34px;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }
    `,
};

addressDrawerFulfillmentMethodSelectorStyles.pickUpRadio = {
    css: css`
        &&&& {
            margin-top: 0;
        }
    `,
};
